export default function(performances) {
  let now = new Date().getTime();
  return performances.filter(function(performance) {
    let dt = new Date(performance.perf_dt).getTime();
    return dt >= now;
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/filterPastPerformances.js